import { FC } from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import SolicitudCredito from "../interfaces/SolicitudCredito.interface";
import Cliente from "../interfaces/Cliente.interface";
import FechaTool from "../tools/Fecha.tool";
import TiempoTool from "../tools/Tiempo.tool";
import { Col, Row } from "reactstrap";
import colors from "../config/Colors.config";

import logo from "../assets/img/logo2.png";
import Valor from "../interfaces/Valor.interface";
import Numero from "../tools/Numero.tool";

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 12,
    },
    section: {
        marginBottom: 10
    },
    title: {
        fontSize: 18,
        marginBottom: 10,
        fontWeight: "bold"
    },
    tableColHeader: {
        width: "25%",
        border: "1px solid #3B73A0",
        backgroundColor: "#3B73A0",//colors.azul,//"#0F6192",
        color: "#FFFFFF",
        padding: 5,
        fontWeight: "bold",
        fontSize: 10
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCol: {
        width: "25%",
        border: "1px solid #3B73A0",
        padding: 5,
        fontSize: 9
    },
    footerRight: {
        position: 'absolute',
        bottom: 35,
        left: 30,
        right: 30,
        textAlign: 'right',
        fontSize: 10,
    },
    footerLeft: {
        position: 'absolute',
        bottom: 35,
        left: 30,
        right: 30,
        textAlign: 'left',
        fontSize: 10,
    },
    absolutePosition: {
        fontSize: 10,
    }
});

const calcularHorasTrabajo = (cliente: Cliente): string => {
    // const horaEntrada: string = cliente.trabajo.horaEntrada;
    // const horaSalida: string = cliente.trabajo.horaSalida;
    const [h1, m1] = cliente.trabajo.horaEntrada.split(":").map(Number);
    const [h2, m2] = cliente.trabajo.horaSalida.split(":").map(Number);
    const minutosEntrada = h1 * 60 + m1;
    const minutosSalida = h2 * 60 + m2;

    const diferencia = minutosSalida - minutosEntrada;

    const horas = Math.floor(diferencia / 60);
    const minutos = diferencia % 60;
    const tiempoTrabajado: string = `${horas} horas, ${minutos} minutos`;

    return tiempoTrabajado

};

const SolicitudCreditoPdf: FC<{ cliente: Cliente, solicitudCredito: SolicitudCredito, operacionesMontos: Valor[], operacionesNumeros: Valor[], operacionesFrecuencias: Valor[] }> = ({ cliente, solicitudCredito, operacionesMontos, operacionesNumeros, operacionesFrecuencias }) => (

    <Document>
        <Page size="A4" style={styles.page}>

            <View>
                <Row style={{ color: colors.blanco, marginRight: "15px", marginLeft: "15px", }}                >
                    <Col>
                        <Image src={logo} style={{ height: "40", width: "65px", marginTop: "0px" }} />

                    </Col>
                    <Col style={{ textAlign: "center", marginTop: "-40px" }}                    >
                        <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >Operadora Tzedaká, S.A.P.I. DE C.V</Text>
                        <Text style={{ color: colors.negro, fontWeight: "bold", marginTop: "5px", fontSize: 14 }} >Solicitud de Crédito</Text>
                    </Col>
                </Row>
            </View>

            <View style={{ marginTop: 30 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }}                >
                    ENTREVISTA INICIAL DE IDENTIFICACIÓN Y CONOCIMIENTO DEL CLIENTE PERSONAS FISICAS DE NACIONALIDAD MEXICANA O EXTRANJERA
                </Text>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "50%" }}>Lugar donde se lleva a cabo la entrevista</Text>
                    <Text style={{ ...styles.tableColHeader, width: "50%", textAlign: "right" }}>Fecha</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "50%" }}> {cliente.lugarEntrevista} </Text>
                    <Text style={{ ...styles.tableCol, width: "50%", textAlign: "right" }}> {FechaTool.convertirLetras(solicitudCredito.fechaCreacion).split(",")[0]}, {FechaTool.formato(solicitudCredito.fechaCreacion)} </Text>
                </View>
            </View>

            <View style={{ marginTop: 10 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }} >
                    DATOS DEL CLIENTE
                </Text>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Apellido Paterno </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Apellido Materno </Text>
                    <Text style={{ ...styles.tableColHeader, width: "34%" }}> Nombre(s) </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.paterno} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.materno} </Text>
                    <Text style={{ ...styles.tableCol, width: "34%" }}> {cliente.nombres} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Fecha de Nacimiento </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Genero </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Estado Nacimiento </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Pais de Nacimiento </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Nacionalidad </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {FechaTool.formato(cliente.fechaNacimiento)} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.genero.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.estadoNacimiento.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.paisNacimiento.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.nacionalidad.nacionalidad} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "100%" }}> Actividad, ocupación, profesión, actividad o giro a que se dedique el cliente.  </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "100%" }}> {cliente.actividadProfecion.value} ({cliente.actividadProfecion.tipo.value}) </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "40%" }}> Nombre de la calle o avenida </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> No. Exterior </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> No. Interior </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> Colonia </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> Ciudad </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "40%" }}> {cliente.calleAvenida} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.numeroExterioir} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.numeroInterioir} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.colonia.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.ciudadRecidencia.value} </Text>
                </View>
            </View>
            <View style={{ marginTop: 0 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "40%" }}> Municipio </Text>
                    <Text style={{ ...styles.tableColHeader, width: "30%" }}> Entidad Federativa </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> Codigo Postal </Text>
                    <Text style={{ ...styles.tableColHeader, width: "15%" }}> Pais </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "40%" }}> {cliente.municipioRecidencia.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "30%" }}> {cliente.estadoRecidencia.value} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.CP} </Text>
                    <Text style={{ ...styles.tableCol, width: "15%" }}> {cliente.paisRecidencia.value} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Numero de Telefono </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Extencion </Text>
                    <Text style={{ ...styles.tableColHeader, width: "34%" }}> Correo electronico </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.numeroTelefono} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.numeroTelefonoExtencion} </Text>
                    <Text style={{ ...styles.tableCol, width: "34%" }}> {cliente.correo} </Text>
                </View>
            </View>
            <View style={{ marginTop: 0 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> RFC </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> CURP </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.RFC} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.CURP} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Nombre de la identificacion</Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Autoridad que la emite </Text>
                    <Text style={{ ...styles.tableColHeader, width: "34%" }}> Numero de la identificacion </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.identificacionNombre} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.identificacionAutoridadEmite} </Text>
                    <Text style={{ ...styles.tableCol, width: "34%" }}> {cliente.identificacionNumero} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "100%" }}> Domicilio en el extranjero donde puedan recibir correspondencia </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "100%%" }}> {cliente.direccionExtranjero} </Text>
                </View>
            </View>


            <View style={styles.footerLeft}>
                <Text>Asesor: {solicitudCredito.usuario.nombre}</Text>
                <Text>
                    Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                </Text>
            </View>
            <View style={styles.footerRight}  >
                <Text render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages} `
                )} fixed />

            </View>
        </Page>

        <Page size="A4" style={styles.page}>

            <View style={{ marginTop: 10 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }} >
                    DOCUMENTACION DEL CLIENTE
                </Text>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Tiene credencia para votar</Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Tiene Extranjero / Pasaporte </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Tiene Otra identificacion </Text>
                    <Text style={{ ...styles.tableColHeader, width: "40%" }}> Descripcion de otra identificacion </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.tieneCredencialParaVotar === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.tieneExtrangeroPasaporte === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.tieneOtraIdentificacion === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "40%" }}> {cliente.tieneOtraIdentificacionDescripcion} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Tiene CURP </Text>
                    <Text style={{ ...styles.tableColHeader, width: "40%" }}> Tiene Cedula de identificaicon Fiscal del SAT </Text>
                    <Text style={{ ...styles.tableColHeader, width: "40%" }}> Tiene constancia de FIEL actualizada </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.tieneCRUP === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "40%" }}> {cliente.tieneCedulaSAT === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "40%" }}> {cliente.tieneFIEL === 1 ? "SI" : "NO"} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Recibo de pago de servicio </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Descripcion del pago de servicio </Text>
                    <Text style={{ ...styles.tableColHeader, width: "34%" }}> Contrato de arrendamiento vigente </Text>

                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.tieneReciboPagoServicio === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.tieneReciboPagoServicioDescripcion} </Text>
                    <Text style={{ ...styles.tableCol, width: "34%" }}> {cliente.tieneContratoArrendamientoVigente === 1 ? "SI" : "NO"} </Text>

                </View>
            </View>
            <View style={{ marginTop: 0 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Estado de cuenta bancarios </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Constancia de inscripcion al RFC </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.tieneEstadoCuentaBancario === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.tieneConstanciaInscripcionRFC === 1 ? "SI" : "NO"} </Text>
                </View>
            </View>

            <View style={{ marginTop: 10 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }} >
                    TERCEROS RELACIONADOS
                </Text>
            </View>
            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "50%" }}> Actua a nombre propio o por cuenta de un tercero </Text>
                    <Text style={{ ...styles.tableColHeader, width: "50%" }}> Descripcion del tercero </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "50%" }}> {cliente.actuaNombrePropio === 0 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "50%" }}> {cliente.actuaNombrePropioDescripcion} </Text>
                </View>
            </View>
            <View style={{ marginTop: 0 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "50%" }}> Alguien distinto aporta recursos para realizar pagos </Text>
                    <Text style={{ ...styles.tableColHeader, width: "50%" }}> Descripcion </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "50%" }}> {cliente.alguienAporteRecursos === 0 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "50%" }}> {cliente.alguienAporteRecursosDescripcion} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "100%" }}> El cónyuge o pariente hasta el segundo grado por consanguinidad o afinidad desempeña o ha desempeñado funciones públicas destacadas en un país extranjero o en territorio nacional, considerando entre otros, a los jefes de estado o de gobierno, líderes políticos, funcionarios gubernamentales, judiciales o militares de alta jerarquía, altos ejecutivos de empresas estatales o funcionarios o miembros importantes de partidos políticos y organizaciones internacionales  </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "100%" }}> {cliente.tieneFamiliaPolitica === 1 ? "SI" : "NO"} </Text>
                </View>
            </View>
            {
                cliente.tieneFamiliaPolitica === 0 &&
                <>
                    <View style={{ marginTop: 0 }} >
                        <View style={styles.tableRow}>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Nombre completo </Text>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Parentesco </Text>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Puesto </Text>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Nacional / Extranjero</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.familiaPoliticaNombreCompleto} </Text>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.familiaPoliticaParentesto} </Text>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.familiaPoliticaPuesto} </Text>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.familiaPoliticaNacionalExtranjero === 0 ? "Extranjero" : "Nacional"} </Text>
                        </View>
                    </View>
                    <View style={{ marginTop: 0 }} >
                        <View style={styles.tableRow}>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Inicio del periodo </Text>
                            <Text style={{ ...styles.tableColHeader, width: "25%" }}> Final del periodo </Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {FechaTool.formato(cliente.familiaPoliticaFechaInicioPeriodo)} </Text>
                            <Text style={{ ...styles.tableCol, width: "25%" }}> {FechaTool.formato(cliente.familiaPoliticaFechaFinalPeriodo)} </Text>
                        </View>
                    </View>
                </>
            }

            <View style={{ marginTop: 10 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }} >
                    PERFIL TRANSACCIONAL
                </Text>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tiene sueldo </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tiene honorarios </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tiene ventas de negocio </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tiene venta de su inmueble</Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tiene herencia </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.tieneSueldo === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.tieneHonorarios === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.tieneVentaNegocio === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.tieneVentaInmueble === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.tieneHerencia === 1 ? "SI" : "NO"} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Tipo de operacion </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Monto de operacion </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Numero de operacion </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Frecuencia de operacion</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> Efectivo </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesMontos.find((item: Valor) => item.Id === cliente.operaciones.efectivo.IdMonto)?.valor} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesNumeros.find((item: Valor) => item.Id === cliente.operaciones.efectivo.IdNumero)?.valor}</Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesFrecuencias.find((item: Valor) => item.Id === cliente.operaciones.efectivo.IdFrecuencia)?.valor}</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> Transferencia </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesMontos.find((item: Valor) => item.Id === cliente.operaciones.transferencia.IdMonto)?.valor} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesNumeros.find((item: Valor) => item.Id === cliente.operaciones.transferencia.IdNumero)?.valor}</Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {operacionesFrecuencias.find((item: Valor) => item.Id === cliente.operaciones.transferencia.IdFrecuencia)?.valor}</Text>
                </View>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Moneda Nacional </Text>
                    <Text style={{ ...styles.tableColHeader, width: "33%" }}> Moneda Extranjera </Text>
                    <Text style={{ ...styles.tableColHeader, width: "34%" }}> Activos Virtuales </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.esMonedaNacional === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "33%" }}> {cliente.esMonedaExtranjera === 1 ? "SI" : "NO"} </Text>
                    <Text style={{ ...styles.tableCol, width: "34%" }}> {cliente.esActivosVirtuales === 1 ? "SI" : "NO"} </Text>
                </View>
            </View>

            <View style={styles.footerLeft}>
                <Text>Asesor: {solicitudCredito.usuario.nombre}</Text>
                <Text>
                    Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                </Text>
            </View>
            <View style={styles.footerRight}  >
                <Text render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages} `
                )} fixed />

            </View>

        </Page>

        <Page size="A4" style={styles.page}>

            <View style={{ marginTop: 10 }} >
                <Text style={{ color: colors.negro, fontWeight: "bold", fontSize: 11 }} >
                    DATOS DEL TRABAJO
                </Text>
            </View>

            <View style={{ marginTop: 2 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Puesto / Cargo </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Area o Departamento </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Fecha de Ingreso</Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Fecha de Salida </Text>
                    <Text style={{ ...styles.tableColHeader, width: "20%" }}> Antiguedad</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.trabajo.puestoCargo} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.trabajo.areaDepartamento} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {FechaTool.formato(cliente.trabajo.fechaIngreso)} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {FechaTool.formato(cliente.trabajo.fechaSalida)} </Text>
                    <Text style={{ ...styles.tableCol, width: "20%" }}> {cliente.trabajo.antiguedad} </Text>
                </View>
            </View>


            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Nombre de la empresa </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Giro o actividad de la empresa </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Direccion de la empresa </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Telefono de la empresa </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.trabajo.nombreEmpresa} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.trabajo.giroActividadEmpresa} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {cliente.trabajo.direccionEmpresa} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {Numero.formatPhoneNumber(cliente.trabajo.telefonoEmpresa)} </Text>
                </View>
            </View>

            <View style={{ marginTop: 5 }} >
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Dias que trabaja </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Hora de entrada </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Horas de salida </Text>
                    <Text style={{ ...styles.tableColHeader, width: "25%" }}> Horas trabajadas </Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCol, width: "25%" }}>
                        {cliente.trabajo.trabajaLunes === 1 ? "Lunes" : ""}{" "}
                        {cliente.trabajo.trabajaMartes === 1 ? "Martes" : ""}{" "}
                        {cliente.trabajo.trabajaMiercoles === 1 ? "Miercoles" : ""}{" "}
                        {cliente.trabajo.trabajaJueves === 1 ? "Jueves" : ""}{" "}
                        {cliente.trabajo.trabajaViernes === 1 ? "Viernes" : ""}{" "}
                        {cliente.trabajo.trabajaSabado === 1 ? "Sabado" : ""}{" "}
                        {cliente.trabajo.trabajaDomingo === 1 ? "Domingo" : ""}
                    </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {TiempoTool.convertTimeTo12HourFormat(cliente.trabajo.horaEntrada)} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {TiempoTool.convertTimeTo12HourFormat(cliente.trabajo.horaSalida)} </Text>
                    <Text style={{ ...styles.tableCol, width: "25%" }}> {calcularHorasTrabajo(cliente)} </Text>
                </View>
            </View>

            <View style={{ ...styles.absolutePosition, marginTop: 30 }}>
                <Text
                    style={{
                        textAlign: "justify",
                        fontSize: "10px",
                        // marginRight: "15px",
                        // marginLeft: "15px"
                    }}
                >
                    Por este medio autorizo expresamente a Operadora Tzedaká S.A.P.I de C.V. para que por conducto de sus colaboradores lleve a cabo investigaciones
                    sobre mi comportamiento e historial crediticio, así como cualquier otra información de naturaleza análoga en las sociedades de información Crediticia
                    que estime conveniente; así mismo declaro que conozco la naturaleza y alcance de la información, así como el uso que Operadora Tzedaká S.A.P.I de C.V.
                    hará de la información y del hecho que Operadora Tzedaká S.A.P.I de C.V. podrá realizar consultas periódicas de mi historial crediticio durante el tiempo
                    que mantenga relación jurídica. Estoy consciente y autorizo que este documento quede en propiedad de Operadora Tzedaká S.A.P.I de C.V. para efectos de
                    control y cumplimiento de la ley para regular a las sociedades de Información Crediticia, asi mismo declaro bajo protesta de decir la verdad que la información
                    compartida en esta encuesta es verídica y comprobable.
                </Text>

                <View style={{ flexDirection: "row", }} >
                    <View style={{ flex: 1, alignItems: "center", }} >
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px",
                                marginTop: "20px",
                            }}
                        >
                            ____________________________________
                        </Text>
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px",
                                marginTop: "20px"
                            }}
                        >
                            Cliente
                        </Text>
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px"
                            }}
                        >
                            {cliente.nombres} {cliente.paterno} {cliente.materno}
                        </Text>
                    </View>

                    <View style={{ flex: 1, alignItems: "center", }} >
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px",
                                marginTop: "20px"
                            }}
                        >
                            ____________________________________
                        </Text>
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px",
                                marginTop: "20px"
                            }}
                        >
                            Asesor
                        </Text>
                        <Text
                            style={{
                                textAlign: "center",
                                fontSize: "10px"
                            }}
                        >
                            {solicitudCredito.usuario.nombre}
                        </Text>
                    </View>

                </View>


            </View>

            <View style={styles.footerLeft}>
                <Text>Asesor: {solicitudCredito.usuario.nombre}</Text>
                <Text>
                    Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                </Text>
            </View>
            <View style={styles.footerRight}  >
                <Text render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages} `
                )} fixed />

            </View>

        </Page>

    </Document >
);

export default SolicitudCreditoPdf;